<template>
    <div class="row justify-content-center">
        <div :class="{'col-lg-8': ! isEditing, 'col-lg-12': isEditing}">
            <div class="wizard month-wizard">
                <div class="wizard-header">
                    <h3>
                        {{ $t('Планирование бюджета на') }} {{ formatMonthName(date) }}
                    </h3>
                </div>
                <div class="wizard-container">
                    <div class="row">
                        <div :class="{'py-3': true, 'col-12': ! isEditing, 'col-lg-6 border-right': isEditing}">
                            <div class="row" v-if="step === 1">
                                <div class="col-12 border-bottom mb-3" v-if="isEditing">
                                    <p>Не рекомендуем редактировать бюджет на месяц после того как вы его создали, вам стоит планировать бюджет более тчательнее что бы не прибегать к его редактированию в дальнейшем.</p>
                                    <p>Редактирование бюджета полвияет на сумму трат в день, и изменит ее для всего месяца, так же вы не увидите реальной картины придерживания заранее запланированного плана. <span v-if="false">Для более тчательного планирования бюджета, и что бы не терять прогрес за весь месяц и видеть реальную динамику перейдите на <router-link to="/subscription">расширенный бюджет</router-link>.</span></p>
                                </div>
                                <div class="col-12 border-bottom">
                                    <div class="wizard-header">
                                        <h5>Доход</h5>
                                        <ul class="yes-no">
                                            <li class="yes-no__item yes-no__item--yes"><strong>Укажите на что вы планируете жить в выбранный месяц</strong>: зарплата, подарки, дополнительные доходы</li>
                                            <li class="yes-no__item yes-no__item--no"><strong>Не записывайте доход который вы не планируете использовать в этом месяце</strong>, такие доходы лучше хранить на отдельных счетах, не привязаных к выбранному бюджету (депозиты, резервные счета).</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12 mt-3">
                                    <div class="row">
                                        <div class="col-12 mb-2 d-flex outcome-line-tip">
                                            <div class="w-60 pl-2">Категория</div>
                                            <div class="pl-2">Сумма</div>
                                        </div>
                                        <div class="col-lg-12 outcome-line" v-for="(category, index) in form.income.categories" :key="index">
                                            <div class="input-group">
                                                <div class="input-group-prepend w-60">
                                                    <multiselect v-model="form.income.categories[index].category" :options="availableIncomeCategoriesToSelect" :placeholder="$t('Категория')" label="name" track-by="id"></multiselect>
                                                </div>
                                                <input type="tel" v-model="form.income.categories[index].value" :class="{'form-control': true, 'is-invalid': form.income.categories[index].error === true}" :placeholder="$t('Сумма')">
                                                <div class="input-group-append value-currency">
                                                    <span class="input-group-text" v-html="$options.filters.currency(980)"></span>
                                                    <button type="button" class="btn btn-danger btn-sm" @click.prevent="removeIncomeCategory(index)" v-if="isEditing"><i class="fas fa-trash"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 mt-3">
                                            <button @click.prevent="addCategoryToIncome" class="btn btn-sm btn-outline-secondary btn-split"><i class="fas fa-plus"></i> <span>Добавить еще</span></button>
                                        </div>
                                        <div class="col-lg-6 mt-3 justify-content-end d-flex align-items-center">
                                            <p class="mb-0">Итого: <strong>{{ incomeSum | money }}</strong> <strong v-html="$options.filters.currency(980)"></strong></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 border-top pt-3 mt-3 text-right">
                                    <router-link :to="`/budget/${budget}`" class="btn btn-outline-secondary mr-2">{{ $t('Отмена') }}</router-link>
                                    <button type="button" class="btn btn-success" @click="step = 2">Далее</button>
                                </div>
                            </div>
                            <div class="row" v-if="step === 2">
                                <div class="col-12 border-bottom">
                                    <div class="wizard-header">
                                        <h5>Расходы</h5>
                                        <ul class="yes-no">
                                            <li class="yes-no__item yes-no__item--yes"><strong>Цели и сбережения.</strong> Если хотите отложить какую-то сумму, укажите это.</li>
                                            <li class="yes-no__item yes-no__item--yes"><strong>Обязательные платежи.</strong> Оплата аренды за квартиру, замена тормозных колодок в машине, налоги, долги, абонемент в спортзал.</li>
                                            <li class="yes-no__item yes-no__item--yes"><strong>Запланированные покупки.</strong> Покупка нового телефона, путешениствия, покупка новой одежды.</li>
                                            <li class="yes-no__item yes-no__item--yes"><strong>Случайные траты.</strong> Укажите часть от дохода, что бы покрыть неожиданные и крупные траты.</li>
                                            <li class="yes-no__item yes-no__item--no"><strong>Повседневные траты.</strong> Покупка продуктов для приготовления еды, покупка утреннего кофе, метро на работу.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="available-to-budget">
                                        <span class="text-muted">Доступно:</span>
                                        <span class="available-to-budget__values">
                                            <strong class="available-to-budget__value ">{{ budgetAvailable | money }} ₴ ⋅ {{ budgetAvailablePerDay | money }} ₴/день</strong>
                                        </span>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12 mb-2 d-flex outcome-line-tip">
                                            <div class="w-60 pl-2">Категория</div>
                                            <div class="pl-2">Сумма</div>
                                        </div>
                                        <div class="col-lg-12 outcome-line" v-for="(category, index) in form.outcome.categories" :key="index">
                                            <div class="input-group">
                                                <div class="input-group-prepend w-60">
                                                    <multiselect v-model="form.outcome.categories[index].category" :options="availableOutcomeCategoriesToSelect" :placeholder="$t('Категория')" label="name" track-by="id"></multiselect>
                                                </div>
                                                <input type="number" v-model="form.outcome.categories[index].value" :class="{'form-control': true, 'is-invalid': form.outcome.categories[index].error === true}" :placeholder="$t('Сумма')">
                                                <div class="input-group-append value-currency">
                                                    <span class="input-group-text" v-html="$options.filters.currency(980)"></span>
                                                    <button type="button" class="btn btn-danger btn-sm" @click.prevent="removeOutcomeCategory(index)" v-if="isEditing"><i class="fas fa-trash"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 mt-3">
                                            <button @click.prevent="addCategoryToOutcome" class="btn btn-sm btn-outline-secondary btn-split"><i class="fas fa-plus"></i> <span>Добавить еще</span></button>
                                        </div>
                                        <div class="col-lg-6 mt-3 justify-content-end d-flex align-items-center">
                                            <p class="mb-0">Итого: <strong>{{ outcomeSum | money }}</strong> <strong v-html="$options.filters.currency(980)"></strong></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 border-top pt-3 mt-3 text-right">
                                    <button type="button" class="btn btn-outline-secondary mr-2" @click.prevent="step = 1">{{ $t('Назад') }}</button>
                                    <button type="button" class="btn btn-success" @click="step = 3">Далее</button>
                                </div>
                            </div>
                            <div class="row" v-if="step == 3">
                                <div class="col-12 d-flex justify-content-center align-items-center text-center flex-wrap">
                                    <div class="outcome-total w-100">
                                        {{ budgetAvailablePerDay | money }} 
                                        <span class="currency" v-html="$options.filters.currency(980)"></span>
                                    </div>
                                    <span class="text-muted mb-4">можно тратить каждый день</span>
                                </div>
                                <div class="col-12 border-top pt-3">
                                    <ul class="yes-no mb-3">
                                        <li class="yes-no__item yes-no__item--yes">Эту сумму вы можете тратить каждый день на что угодно - главное, что бы не выходить за ее пределы в день.</li>
                                        <li class="yes-no__item yes-no__item--yes">Такая сумма будет доступна Вам для трат каждый день.</li>
                                        <li class="yes-no__item yes-no__item--yes">Если вы потратие больше этой суммы в какой-то из дней, на следующий день сумма будет меньше.</li>
                                        <li class="yes-no__item yes-no__item--yes">Если вы потратие меньше этой суммы в какой-то из дней, остаток будет добавлен на следующий день.</li>
                                        <li class="yes-no__item yes-no__item--yes">Что бы плановые расходы которые вы указали не учитывались в бюджет дня, вам следует указывать соответвующие категории.</li>
                                    </ul>
                                </div>
                                <div class="col-12 border-top pt-3 text-right">
                                    <button type="button" class="btn btn-outline-secondary mr-2" @click.prevent="step = 2">{{ $t('Назад') }}</button>
                                    <button type="button" class="btn btn-success" @click="store">Сохранить</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 py-3" v-if="isEditing">
                            <p>Вы можете выключить категории из учета в этом месяце, что бы более правильно рассчитывать ваши расходы в этом месяце.</p>
                            <p v-if="false">С <a href="">подпиской</a> вы сможете дополнительно управлять отдельными транзакциями на конкретные дни.</p>

                            <div class="categories">
                                <div :class="{'category-item': true, 'checked': ! isCategoryIgnored(category.category_id)}" 
                                    @click="toggleIgnoreCategory(category.category_id)"
                                    :key="category.category_id" 
                                    v-for="category in enabledCategories">
                                    <span class="name" v-text="category.category"></span>
                                    <span class="amount">{{ category.amount | money }} <strong v-html="$options.filters.currency(980)"></strong></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: "MonthWizrd",

    props: ['date', 'budget'],

    data: function() {
        return {
            step: 1,

            form: {
                outcome: {
                    value: 0,
                    categories: [],
                },
                income: {
                    value: 0,
                    categories: [],
                },
            },
            
            enabledCategories: [],
            ignoreCategoires: [],

            month: {},

            errors: {},
        };
    },
    
    watch: {
        'date': function() {
            this.initWizard();
        },
    },
    
    mounted() {
        this.loadCategories();

        this.initWizard();
    },

    computed: {
        ...mapGetters(['categories']),

        availableOutcomeCategoriesToSelect() {
            return this.categories.filter((category) => {
                return ! this.form.outcome.categories.find((item) => item.category && item.category.id === category.id && category.expenses);
            });
        },

        availableIncomeCategoriesToSelect() {
            return this.categories.filter((category) => {
                return ! this.form.outcome.categories.find((item) => item.category && item.category.id === category.id && category.incomes);
            });
        },

        outcomeSum() {
            let amount = 0;

            for(let i = 0; i < this.form.outcome.categories.length; i++) {
                amount += parseInt(this.form.outcome.categories[i].value) * 100;
            }

            return amount;
        },

        incomeSum() {
            let amount = 0;

            for(let i = 0; i < this.form.income.categories.length; i++) {
                amount += parseInt(this.form.income.categories[i].value) * 100;
            }

            return amount;
        },

        budgetAvailable() {
            return this.incomeSum - this.outcomeSum;
        },

        budgetAvailablePerDay() {
            return this.budgetAvailable / moment().daysInMonth();
        },

        isEditing() {
            return this.month.id;
        }
    },

    methods: {
        ...mapActions(['loadCategories']),

        formatMonthName(date) {
            return moment(date, 'DD-MM-YYYY').format('MMMM YYYY');
        },

        initWizard(dontLoad = false) {
            this.step = 1;

            this.form = {
                outcome: {
                    value: 0,
                    categories: [],
                },
                income: {
                    value: 0,
                    categories: [],
                },
            };

            this.enabledCategories = [];
            this.ignoreCategoires = [];

            this.addCategoryToOutcome();
            this.addCategoryToOutcome();
            this.addCategoryToOutcome();

            this.addCategoryToIncome();
            this.addCategoryToIncome();
            this.addCategoryToIncome();

            if(! dontLoad) {
                this.loadMonthInfo();
            }
        },

        loadMonthInfo() {
            axios.get(`/budget/${this.budget}/month/${this.date}`)
                .then(({data}) => {
                    data.data.outcome.categories = this.transformCategories(data.data.outcome.categories);
                    data.data.income.categories = this.transformCategories(data.data.income.categories);

                    this.form.outcome = data.data.outcome;
                    this.form.income = data.data.income;

                    if(data.data.month && data.data.month.length !== 0) {
                        this.month = data.data.month;
                        this.enabledCategories = data.data.categories;
                        this.ignoreCategoires = data.data.ignores;
                    } else {
                        this.initWizard(true);
                    }
                }).catch(({response}) => {
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error'); 
                });
        },

        transformCategories(categories) {
            return categories.map((item) => {
                return {
                    category: this.availableOutcomeCategoriesToSelect.find((category) => item.category_id === category.id),
                    value: item.value / 100,
                    error: false,
                };
            });
        },

        store() {
            this.$ga.event('monthStore', 'clicked');

            axios.post(`/budget/${this.budget}/month/${this.date}`, this.form)
                .then(({data}) => {

                    this.$ga.event('monthStore', 'planned');

                    this.$emit('planned', data);
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        toggleCategory(id) {
            axios.post(`/budget/${this.budget}/month/${this.date}/category/${id}`)
                .then(({data}) => {
                    //
                }).catch(({response}) => {
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        addCategoryToOutcome() {
            this.form.outcome.categories.push({
                category: null,
                value: 0,
                error: false,
            });
        },

        addCategoryToIncome() {
            this.form.income.categories.push({
                category: null,
                value: 0,
                error: false,
            });
        },

        removeIncomeCategory(index) {
            this.form.income.categories.splice(index, 1);

            if(this.form.income.categories.length === 0) {
                this.addCategoryToIncome();
            }
        },

        removeOutcomeCategory(index) {
            this.form.outcome.categories.splice(index, 1);

            if(this.form.outcome.categories.length === 0) {
                this.addCategoryToOutcome();
            }
        },

        toggleIgnoreCategory(id, index) {
            if(this.isCategoryIgnored(id)) {
                this.ignoreCategoires = this.ignoreCategoires.filter(item => item !== id);
            } else {
                this.ignoreCategoires.push(id);
            }

            this.toggleCategory(id);
        },

        isCategoryIgnored(id) {
            return !! this.ignoreCategoires.find(item => item === id);
        }
    },
}
</script>

<style lang="scss">
.wizard {
    .wizard-header {
        h3 {
            //
        }
    }

    &.month-wizard {
        .wizard-container {
            padding: 0;
        }
    }

    .outcome-total {
        font-size: 100px;
        font-weight: bold;
        white-space: nowrap;
        text-align: center;
    }

    .yes-no {
        list-style-type: none;
        margin: 0 0 2em;
        color: #4c4c4c;
        max-width: 42em;
        font-size: 14px;
        padding-left: 0;
        margin: 0;

        .yes-no__item {
            position: relative;
            padding-left: 20px;
            margin-bottom: 5px;

            &:before {
                content: "";
                position: absolute;
                width: 16px;
                height: 16px;
                left: 1px;
                top: 3px;
            }

            &.yes-no__item--yes:before {
                background: url("../../assets/images/bullet-check.svg") no-repeat 0 0;
            }

            &.yes-no__item--no:before {
                background: url("../../assets/images/bullet-cross.svg") no-repeat 0 0;
            }
        }
    }

    .available-to-budget {
        margin: 15px 0;

        .available-to-budget__values {
            display: block;
            font-size: 16px;

            .available-to-budget__value {
                display: inline-block;
                width: 100%;
            } 
        }
    }

    .multiselect {
        min-height: auto;

        .multiselect__tags {
            min-height: auto;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            border-color: #ced4da;

            .multiselect__placeholder {
                margin-bottom: 5px;
                padding: 1px 0;
            }
        }

        .multiselect__content-wrapper {
            //
        }
    }

    .outcome-line-tip {
        font-size: 12px;
    }

    .outcome-line {
        &:nth-child(2) {
            .multiselect {
                .multiselect__tags {
                    border-top-left-radius: 3px;
                }
            }

            .value-currency {
                .input-group-text {
                    border-top-right-radius: 3px!important;
                }
            }

            .btn {
                border-top-right-radius: 3px!important;
            }
        }

        .multiselect {
            .multiselect__tags {
                border-bottom-width: 0;
            }
        }

        .form-control {
            border-bottom-width: 0;
        }

        .value-currency {
            .input-group-text {
                border-bottom-width: 0;
            }
        }

        .btn {
            border-bottom-width: 0;
            border-radius: 0;
        }

        &:nth-last-child(3) {
            .multiselect {
                .multiselect__tags {
                    border-bottom-left-radius: 3px;
                    border-bottom-width: 1px;
                }
            }

            .form-control {
                border-bottom-width: 1px;
            }

            .value-currency {
                .input-group-text {
                    border-bottom-width: 1px;
                    border-bottom-right-radius: 3px!important;
                }
            }

            .btn {
                border-bottom-width: 1px;
                border-bottom-right-radius: 3px!important;
            }
        }
    }
}

.categories {
    .category-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #212529;
        background: rgba(166, 168, 179, 0.12);
        border-radius: 5px;
        padding: 5px 10px;
        margin: 5px 0;
        margin-left: 5px;
        width: 100%;
        position: relative;
        opacity: 0.6;
            border: 1px solid transparent;

        &.checked {
            opacity: 1;
            border: 1px solid rgba(51, 110, 189, 0.12);
        }
            
        .name {
            word-break: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 10px;
        }

        .amount {

        }
    }
}
</style>